<template>
  <div class="w-100 h-100">
    <vue-apex-charts
      :ref="`simple-bar-${name}`"
      type="bar"
      :height="height"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'BarChartSimplified',
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: null,
    },
    valueAppend: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '350',
    },
  },
  data() {
    return {
      colors: [
        '#36B37E',
        '#1D79F2',
        '#E34850',
        '#FFAB00',
        '#141A32',
        '#AD6529',
        '#E96D73',
        '#FFCD66',
        '#43485B',
        '#6E6E6E',
        '#CACACA',
        '#81C4AE',
      ],
    }
  },
  computed: {
    series() {
      return [{
        data: this.data.map(el => el.count),
        name: '',
      }]
    },
    options() {
      return {
        chart: {
          height: 350,
          width: '100%',
          type: 'bar',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        colors: this.colors,
        plotOptions: {
          bar: {
            columnWidth: '45%',
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          labels: {
            style: {
              colors: this.colors,
              fontSize: '12px',
            },
          },
          categories: this.data.map(el => el.name),
        },
        yaxis: {
          labels: {
            formatter: val => `${val.toLocaleString()} ${this.valueAppend || ''}`,
          },
        },
        tooltip: {
          y: {
            formatter: value => `${value.toLocaleString()} ${this.valueAppend || ''}`,
          },
          x: {
            formatter: value => `${value.toLocaleString()}`,
          },
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
        responsive: [
          {
            breakpoint: 990,
            options: {
              plotOptions: {
                bar: {
                  horizontal: false,
                },
              },
            },
          },
        ],
      }
    },
  },

}
</script>
